import React from 'react';

import OwnerCommunication from '../../components/Prospecting/OwnerCommunication';

function OwnerCommunicationView() {
  return (
    <OwnerCommunication />
  );
}

export default OwnerCommunicationView;
